import { Controller } from "@hotwired/stimulus";
import Choices from "choices.js";

export default class extends Controller {
  connect() {
    // this avoid multiple initialization of choices
    if (this.element.dataset.choice != "active") {
      this.initializeChoices();
    }

    // workaround to keep a blank option  in the filter dropdowns (hidden for the user)
    // to allow submission without selecting anything
    const optionBlank = document.querySelectorAll(
      '.wrapper-filters .choices__list [data-id="1"]'
    );
    optionBlank.forEach((option) => option.classList.add("d-none"));
  }

  initializeChoices() {
    const options = {
      searchEnabled: false,
      searchChoices: false,
      addItems: false,
      placeholder: true,
      placeholderValue: this.element.dataset.placeholder,
      itemSelectText: "",
      removeItemButton: true,
      shouldSort: false,
    }

    new Choices(this.element, options);
  }
}
